export const DEPARTMENT_ORDER = [
  "组合管理部",
  "固定收益投资部",
  "权益投资部",
  "金融市场中心",
  "风险管理部",
  "法律合规部",
  "交易管理部",
  "运营管理部",
  "信息科技部",
  "办公室（党委办公室、党建工作部）"
];

export const APPLY_JOB_IDS = {
  "1": "aa530311136d1e856d89bac46045bb2a",
  "2": "c77b0e3ab69ce6bd54054eb0b874c51a",
  "3": "3c2b04a7084c945a05aa5615e71eda0a",
  "4": "ed3fff30ed598e0be35742e323d7a7b1",
  "5": "3a32dfd53c6bb718f6c464f7c469f9d1",
  "6": "b17f8f211ccc1f5b8ab3a0d420503095",
  "7": "68380f567e4e57be4be3823131ea52b6",
  "8": "5efc6058cd88de9794bc84841c7787ff",
  "9": "6fc98cb655c9dea9508a7de5d9eecede",
  "10": "3fb6e2a5be8a750b590b319ec13efc25",
  "11": "1aba1d10661e0b3c04534bbedf899eb5",
  "12": "98a503190bfd82cd608f2feaf8033f26",
  "13": "026e72f88f711d7585cdc273bc7abc4a",
  "14": "0f3ca86ba07ccfefcb6ee815515ff284",
  "15": "4bd62da8f03f7e64fcf499665a950944",
  "16": "3f3bda2692fb2c06058e030996efce85",
  "17": "a5bf479100716452b02d7fed1c6199a3",
  "18": "36d766fa1294a0af34474f291325f9b7",
  "19": "0374acbda7d7c5be805064064c42feda",
  "20": "05ce85f11369129dd374c733d540dc2e",
  "21": "0ccd2f56d7c5f628ee9faf6c6ad5e05f",
  "22": "d4cbbd184ad602f692f241dfb657906d",
  "23": "730841d07e60426fbbc812cf247912cc",
  "24": "0d28f9ccf58aeb1d949900c99441e10c",
  "25": "d34429e92d5b44db745cf1856bbff469",
  "26": "c9e24dba441c02960e09ba3f9ae936f7"
};

export const APPLY_PROJECT_ID = "f0eb37ef2977acd71193f7e9590e4783";

export const JOB_DATA = [
  {
    "id": 1,
    "department": "组合管理部",
    "name": "组合配置管理岗（策略研究和配置管理方向）",
    "duties": [
      "1、开展宏观经济和资产配置策略研究，参与多资产量化模型、动态组合管理相关研究；",
      "2、撰写资产配置相关材料，包括但不限于阶段性计划、策略调整建议、执行情况分析、投资业绩评估；",
      "3、参与委受托关系管理、多资产账户组合管理、落实金融“五篇大文章”相关工作、投资相关报告报送和专题分析；",
      "4、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有5年以上（博士不少于4年）国内外金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有3年以上宏观经济/股票策略/固收投资研究、资产配置或保险资金受托管理等相关工作经验，对宏观策略、资产配置、长期配置型资金投资有较深入的理解，有较扎实的投资研究功底，有较强的定量分析能力；",
      "3、工作勤奋，责任心强，认真踏实，问题解决能力强，能适应快节奏的独立或团队工作；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、熟悉保险资金投资特性者、熟练应用人工智能和编程工具者优先；同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、金融工程、经济、会计、财务、管理、法律、数学等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 2,
    "department": "组合管理部",
    "name": "组合配置管理岗（组合数据管理方向）",
    "duties": [
      "1、开展组合数据管理，整合多维度数据，保障数据准确性，开发和管理数据模板，支持组合跟踪、测算、分析工作；",
      "2、对接监管机构、委托人、公司内部的组合管理数据需求，组织协调相关部门，开展相关数据的统计和管理，可能涉及领域包括保险资产配置、资产负债管理、偿付能力、投资业绩管理、金融“五篇大文章”等；",
      "3、参与资产配置、组合管理相关测算和数据分析工作；",
      "4、对接数据治理相关工作，推动组合数据管理自动化；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、 具有3年以上（博士不少于2年）国内外金融机构、会计师事务所或投资相关领域工作经验；",
      "2、具有2年以上组合管理、数据管理和分析、风险管理和咨询或财务会计等相关工作经验，熟悉金融资产特征、保险资产管理业务、会计准则、数据库和编程工具者优先；",
      "3、工作勤奋，责任心强，认真踏实，问题解决能力强，能适应快节奏的独立或团队工作；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、金融工程、经济、会计、财务、管理、法律、数学等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 3,
    "department": "组合管理部",
    "name": "组合配置管理岗（首席研究方向）",
    "duties": [
      "1、负责跟踪研究国内外宏观经济政策，研判市场走势，为公司投资策略和资产配置提供依据；",
      "2、负责分析保险资管行业趋势与业务需求，参与制定公司中长期发展战略，推动业务创新；",
      "3、协助部门建设研究团队，指导研究团队的研究方法与逻辑，搭建成熟专业的研究体系；",
      "4、与国内外知名经济学者、研究机构建立合作关系，提升公司行业影响力；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有10年以上（博士不少于9年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有5年以上大中型保险资产管理公司、公募基金或证券公司等金融机构研究工作经验，具备丰富的研究积累与资源；",
      "3、具有扎实的经济学理论基础和宏观经济分析能力，熟悉国际金融市场和投资策略，能够预测国内外经济趋势并支撑投资决策；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、金融工程、经济、会计、财务、管理、法律、数学等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在45周岁以内"
    ]
  },
  {
    "id": 5,
    "department": "固定收益投资部",
    "name": "固收研究岗（宏观方向）",
    "duties": [
      "1、负责国内国际宏观经济、政策、大类资产配置、利率衍生品等研究；",
      "2、协助制定固定收益投资策略、计划，并配合具体实施；",
      "3、负责配合固定收益类资产跟踪分析及投后管理工作；",
      "4、协助制定及修订固定收益投资相关制度；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上大中型保险资产管理公司、公募基金、证券公司固定收益研究工作经验，有宏观、转债、国债期货，abs，reits等卖方专题研究工作经验者优先；",
      "3、品行良好，熟悉与行业或业务相关的法律法规及监管规定，具有良好的沟通表达能力；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、法律、会计、财务、经济、管理、数学、物理等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 6,
    "department": "固定收益投资部",
    "name": "固收研究岗（转债方向）",
    "duties": [
      "1、负责可转换债券研究和品种挖掘；",
      "2、协助制定可转债及固定+投资策略、计划，并配合具体实施；",
      "3、负责配合固定收益类资产跟踪分析及投后管理工作；",
      "4、协助制定及修订固定收益投资相关制度；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上大中型保险资产管理公司、公募基金、证券公司固定收益研究工作经验，有转债、国债期货，abs，reits等卖方专题研究工作经验者优先；",
      "3、品行良好，熟悉与行业或业务相关的法律法规及监管规定，具有良好的沟通表达能力；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、法律、会计、财务、经济、管理、数学、物理等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 7,
    "department": "权益投资部",
    "name": "股票投资岗（量化方向）",
    "duties": [
      "1、负责量化投资策略的全流程研发，涵盖因子挖掘、模型构建、历史回测、参数优化与实盘迭代；",
      "2、管理或评价量化投资组合，动态监控策略运行、市场数据与组合风险指标，在授权范围内执行交易与组合调整;",
      "3、负责根据市场走势判断，结合投资目标，协助拟定权益类资产投资策略；",
      "4、负责协助拟定权益类资产配置方案；",
      "5、负责定期报告权益类资产投资运行情况；",
      "6、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有5年以上（博士不少于4年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上股票或基金等权益投资经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学、计算机等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在43周岁以内"
    ]
  },
  {
    "id": 8,
    "department": "权益投资部",
    "name": "股票投资岗（成长方向）",
    "duties": [
      "1、负责落实权益类资产投资计划、投资政策和配置方案(偏成长风格)；",
      "2、负责下达投资指令并监督实施；",
      "3、负责根据市场走势判断，结合投资目标，协助拟定权益类资产投资策略；",
      "4、负责协助拟定权益类资产配置方案；",
      "5、负责定期报告权益类资产投资运行情况；",
      "6、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有5年以上（博士不少于4年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上股票或基金等权益投资经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、具有成长型行业研究、投资经验优先；同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、法律、会计、财务、经济、管理、计算机、电子等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在43周岁以内"
    ]
  },
  {
    "id": 9,
    "department": "权益投资部",
    "name": "股票研究岗（成长方向）",
    "duties": [
      "1、负责前沿技术与产业趋势跟踪：深入研究成长型行业，结合产业周期撰写具有前瞻性的深度报告；",
      "2、负责个股深度挖掘与产业链验证，建立严密的“自上而下”产业逻辑与“自下而上”个股挖掘框架，对A/H股上市公司进行深入研究，建立财务预测与估值模型，挖掘投资机会并形成投资建议；",
      "3、负责定期进行公司调研、专家访谈，参加行业会议，及时掌握公司基本面变化和行业最新动向；",
      "4、负责与本岗位有关的资料收集、整理及存档工作；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上成长型行业研究经验；",
      "3、品行良好，熟悉与行业或业务相关的法律法规及监管规定；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学、计算机、电子等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 10,
    "department": "权益投资部",
    "name": "股票投资岗",
    "duties": [
      "1、负责落实权益类资产投资计划、投资政策和配置方案；",
      "2、负责下达投资指令并监督实施；",
      "3、负责根据市场走势判断，结合投资目标，协助拟定权益类资产投资策略；协助拟定权益类资产配置方案；",
      "4、负责定期报告权益类资产投资运行情况；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有5年以上（博士不少于4年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上股票或基金等权益投资经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学、计算机等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在43周岁以内"
    ]
  },
  {
    "id": 11,
    "department": "权益投资部",
    "name": "境外投研岗",
    "duties": [
      "1、负责规划、组织、协调境外投资相关的拓展及管理等工作，制定实施投资计划；组织协调对境外项目开展深度分析、尽职调查、评估和谈判，完成项目的落地工作；",
      "2、对境外投资项目进行储备，做好项目库建设；对存续项目开展投后管理工作；",
      "3、建立和完善项目管理机制与流程规范，开展境外投资的制度建设工作；建立境外业务资源库；",
      "4、积极寻找开拓国际市场的合作渠道；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有5年以上（博士不少于4年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上境外投资或研究经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学、计算机等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在43周岁以内"
    ]
  },
  {
    "id": 12,
    "department": "权益投资部",
    "name": "股票研究岗（量化方向）",
    "duties": [
      "1、负责量化投资策略的研究，涵盖因子挖掘、模型构建、历史回测、参数优化；",
      "2、丰富股票团队策略多样性，开发量化新策略；",
      "3、利用各种金融数据分析工具，进行数据挖掘及加工；",
      "4、与投资经理紧密合作，深入研究策略组合，推动策略的创新与优化；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上量化研究经验；",
      "3、品行良好、熟悉与行业或业务相关的法律法规及监管规定；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、有编程功底者优先;同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学、计算机等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 13,
    "department": "金融市场中心",
    "name": "产品管理岗",
    "duties": [
      "1、负责组合类保险资管产品开发，包括提出产品开发建议、跟进产品开发全流程、落实产品开发过程中的各项问题，对产品开发结果负责；",
      "2、负责组合类保险资管产品的持续管理，包括产品要素变更、投资业绩跟踪、客户需求跟踪了解及应对、投资策略优化建议等；",
      "3、负责对监管政策及时跟进研究，分析行业发展趋势及同业产品策略；",
      "4、完成领导安排的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）保险资管、公募基金、商业银行或证券公司等金融机构从业经验；",
      "2、具有2年以上保险资管、公募基金、商业银行或证券公司等金融机构资管产品开发经验；",
      "3、熟悉组合类产品管理全流程，能够独立进行产品发行工作的优先考虑；曾参与产品策略研究、产品业绩归因分析、代销业务流程、监管信息报送相关工作的优先；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 14,
    "department": "金融市场中心",
    "name": "机构销售岗",
    "duties": [
      "1、负责推进各类金融机构（银行、保险公司等）及企业财务公司等机构客户的渠道开拓、维护与服务工作；",
      "2、负责机构客户的市场调研、分析及沟通洽谈，针对客户的资产配置需求，开展组合类保险资管产品的推介与销售工作；",
      "3、协助完成组合类保险资管产品的发行、设立与销售管理等事务工作；",
      "4、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上机构客户对接、销售或组合类保险资管产品业务经验，熟悉机构客户、组合类产品业务以及主流投资品种的市场情况，具有保险、银行、银行理财子等机构客户资源者优先；",
      "3、具有较强的沟通能力、市场开拓能力、市场洞察力；能适应出差并承受较大工作强度；",
      "4、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 15,
    "department": "风险管理部",
    "name": "风险管理岗",
    "duties": [
      "1、负责建立健全公司风险偏好体系，制定风险管理策略及风险管理制度，识别、评估、量化和监测各大类资产风险；",
      "2、负责投资管理系统、风控系统的风控设置工作，开展盘中、事后的投资监督和提示；",
      "3、负责对新业务、专项业务等进行风险审核，完成风险评估报告；",
      "4、负责对投资组合进行风险评估和绩效分析，完成风险和绩效分析报告；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上保险资管、公募基金或证券公司等金融机构风控相关工作经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、具备编程能力、具备风险管理相关专业资格证书者优先；同等条件下有行业前10公司工作经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学、统计、计算机等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 16,
    "department": "法律合规部",
    "name": "合规管理岗",
    "duties": [
      "1、负责公司合规管理工作，包括牵头制度管理、拟定合规管理基本制度和年度合规管理计划等；",
      "2、负责组织实施合规审查、合规检查、评估评价、合规风险监测与合规事件处理；",
      "3、负责牵头内控、操作风险管理工作，包括投资授权决策管理、内控流程建设与完善、操作风险管理等；",
      "4、负责为公司提供法律合规支持；保持与监管机构日常合规联系；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上保险资管、保险公司或咨询机构内控合规、操作风险管理等相关岗位工作经验；具有反洗钱、案件防控等专项合规工作经验者优先；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、审计等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 17,
    "department": "法律合规部",
    "name": "法律事务岗",
    "duties": [
      "1、负责对公司资产管理项目提供法律支持等相关工作；",
      "2、负责公司法律事务管理工作，包括合同管理、法律文件审核、法律咨询、诉讼管理、涉刑案件管理，组织刑事犯罪预防教育等事项；",
      "3、负责公司法律顾问、外聘律师管理工作；",
      "4、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上保险资金运用、保险资管公司法律事务工作经验，或2年以上资产管理项目法务经验；",
      "3、具备法律职业资格证（A证）；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、有诉讼经验者优先；同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 18,
    "department": "交易管理部",
    "name": "固收交易岗",
    "duties": [
      "1、负责银行间、交易所市场回购、债券、债券借贷及衍生品等品种的交易询价及交易执行等工作，对交易情况进行实时监控和汇报；",
      "2、负责开拓和维护各类交易对手；",
      "3、负责收集、跟踪和反馈投资市场信息，提供投资决策的数据和依据；",
      "4、负责维护交易数据、交易记录，整理并定期归档交易相关资料；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年及以上保险资管、银行、证券或公募基金等金融机构固收交易相关从业经历；",
      "3、具有丰富且稳定的交易对手，掌握资金及现券交易策略，熟悉不同类型机构的交易逻辑及行为特点；",
      "4、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "5、具有银行间本币市场交易员资格证者优先；同等条件下有保险资管行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 19,
    "department": "交易管理部",
    "name": "股票交易岗",
    "duties": [
      "1、负责执行交易所股票和回购等品种交易，对交易情况进行实时监控和汇报；",
      "2、负责收集、跟踪和反馈投资市场信息，提供投资决策的数据和依据；",
      "3、负责维护交易数据、交易记录，整理并定期归档交易相关资料；",
      "4、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上保险资管、银行、证券或公募基金等金融机构股票交易相关从业经历；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、具有证券从业资格证、期货从业资格证者优先；同等条件下有保险资管行业前10公司任职经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 20,
    "department": "运营管理部",
    "name": "估值核算岗",
    "duties": [
      "1、负责投资资产日常估值核算账务处理，确保数据及时、准确；",
      "2、负责拟定并实施估值核算相关制度与业务流程；",
      "3、负责配合提供核算数据与报表等信息，对接托管行、审计等机构；",
      "4、负责估值核算相关系统建设与业务测试；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上保险资管、公募基金或证券公司等金融机构核算相关领域工作经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、具有CPA、ACCA等专业证书优先；同等条件下有行业前10公司工作经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 21,
    "department": "运营管理部",
    "name": "资金清算岗",
    "duties": [
      "1、负责头寸管理与资金划拨；",
      "2、负责投资结算与账户全生命周期管理；",
      "3、负责拟定资金清算相关制度与业务流程；",
      "4、负责资金清算类系统建设、业务测试、优化升级；",
      "5、完成领导交办的其他工作任务。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上保险资管、公募基金或证券公司等金融机构资金清算相关领域工作经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、具有CPA、ACCA等专业证书优先；同等条件下有行业前10公司工作经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 22,
    "department": "运营管理部",
    "name": "数据运营岗",
    "duties": [
      "1、负责监管数据报送及运营数据支持；",
      "2、负责实施数据治理建设相关工作；",
      "3、负责数据运营相关系统建设与业务测试；",
      "4、负责拟定并实施数据相关制度与业务流程；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具有2年以上保险资管、公募基金或证券公司等金融机构数据运营相关领域工作经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、有数据治理经验优先；同等条件下有行业前10公司工作经验者优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、统计、数学等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的大学本科及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 23,
    "department": "信息科技部",
    "name": "系统运维岗",
    "duties": [
      "1、负责业务系统日常监控、故障排查与维护；",
      "2、负责应用系统的配置、变更和升级，确保系统稳定运行，及时处理异常情况，保障业务连续性；",
      "3、为业务部门提供技术支持，协助解决系统使用中的问题；",
      "4、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询公司或中大型知名机构从业经验；",
      "2、具有2年以上资产管理公司、公募基金、银行理财子公司等金融机构系统运维相关工作经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、具备恒生投资交易系统运维经验者优先；同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "数学、计算机、自动化、电子、通信等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的大学本科及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 24,
    "department": "信息科技部",
    "name": "基础设施岗",
    "duties": [
      "1、主机方向：组织管理机房基础设施的综合运维，保障IDC机房安全稳定运行；熟练掌握服务器、存储、操作系统、通用中间件、容器等基础软硬件的运维管理；熟练应用Prometheus/ELK等监控工具具备全线故障定位能力；",
      "2、网络方向：负责公司交易网络、IDC网络等场景的规划、实施、维护、优化、运营工作，负责网络设备的日常监控、运行维护、策略配置、安全加固等工作；",
      "3、安全方向：负责公司网络安全、数据安全、应用安全能力规划与建设；负责信息安全日常监测预警、应急预案制定、安全事件分析处理、安全风险评估等工作；熟悉ISO27001、等级保护2.0等安全标准和框架，熟悉网络安全法、数据安全法、银行保险行业数据安全管理办法等相关法律法规;",
      "4、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询公司或中大型知名机构从业经验；",
      "2、具有2年及以上资产管理公司、公募基金、银行理财子公司等金融机构主机、网络或安全方向相关工作经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、同等条件下有行业前10公司任职经验者优先。"
    ],
    "major": [
      "数学、计算机、自动化、电子、通信、网络空间安全等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的大学本科及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 25,
    "department": "办公室（党委办公室、党建工作部）",
    "name": "战略规划岗",
    "duties": [
      "1、负责拟定公司中、长期发展战略和发展规划；",
      "2、负责对战略规划执行情况进行持续跟踪与评估，适时根据实际情况对规划进行及时调整；",
      "3、负责公司战略合作伙伴的沟通协调工作；负责战略合作各项规划与实施工作；",
      "4、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询机构或中大型知名机构从业经验；",
      "2、具备1年以上保险资管、公募基金、证券公司等金融机构相关领域战略管理经验；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、同等条件下有行业前10公司工作经验者优先。"
    ],
    "major": [
      "金融、法律、会计、财务、经济、管理、数学、统计等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的硕士研究生及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  },
  {
    "id": 26,
    "department": "办公室（党委办公室、党建工作部）",
    "name": "综合管理岗",
    "duties": [
      "1、负责公司总经理办公会、碰头会等重要会议的组织工作；负责公司重大事项督查、督办工作；",
      "2、负责公司OA系统、公司官网等办公系统的管理工作；负责公司公文管理工作；",
      "3、负责公司新闻宣传、品牌宣传、媒体关系及新闻发布等工作；",
      "4、负责公司声誉风险管理、舆情管理工作；负责公司保密管理、工会工作；负责部门年度预算编制工作；",
      "5、完成领导交办的其他工作。"
    ],
    "requirements": [
      "1、具有3年以上（博士不少于2年）金融机构、咨询公司或中大型知名机构从业经验；",
      "2、具有2年以上综合行政、办公室或相关领域同等工作经验，文字功底扎实；",
      "3、认同中邮资管企业文化和经营理念，对保险资管行业充满热情；",
      "4、中共党员优先。"
    ],
    "major": [
      "金融、经济、会计、财务、管理、法律、数学等相关专业"
    ],
    "education": [
      "具有国家主管部门认可的大学本科及以上学历学位"
    ],
    "age": [
      "原则上在40周岁以内"
    ]
  }
];
